// extracted by mini-css-extract-plugin
export var createdDate = "_h9-1";
export var divider = "_h9-2";
export var headerDivider = "_h9-3";
export var messagesCard = "_h9-0";
export var messagesContainer = "_h9-7";
export var messagesContainerWrapper = "_h9-4";
export var pointerCapturingButtonBoxes = "_h9-a";
export var showLeftPanelButton = "_h9-9";
export var showMoreButton = "_h9-c";
export var showMoreButtonContainer = "_h9-b";
export var summaryTitle = "_h9-6";
export var systemMessageCardWrapper = "_h9-d";
export var topButtons = "_h9-8";
export var withPadding = "_h9-5";